<template>
  <input type="password" hidden autocomplete="new-password">
  <!--   注册-->
  <div ref="modelDom" class="modal fade " id="registerModal" tabindex="-1" aria-labelledby="registerModalLabel" aria-hidden="true"
       data-bs-keyboard="false" data-bs-backdrop="static">
    <!--  <div class="modal" tabindex="-1">-->
    <div class="modal-dialog modal-dialog-centered ">
      <div class="modal-content">
        <div class="modal-header bg-primary position-relative text-white">
          <h1 class="modal-title  fw-bold  fs-5  text-center w-100" id="registerLabel">注册</h1>
          <button type="button" class="btn-close btn-close-white position-absolute end-0 px-4 "  @click="registModelOpen(false)"></button>
        </div>
        <div class="modal-body">
          <form class="needs-validation" novalidate ref="formDom" @submit.prevent="save" autocomplete="off"  >
            <!--          用户名-->
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="username" class="col-12 col-md-3 text-start">用户名</label>
              <div class="col-12 col-md-9" >
                <input type="text" style="display: none">
                <input type="text"  autocomplete="one-time-code-xxxx"
                       :readonly="nameReadonly"
                       @focus="nameReadonly=false"
                       @blur="nameReadonly=true"
                       v-model="form.name"
                       class="form-control" required>
                <div class="invalid-feedback">
                  请输入用户名
                </div>
              </div>
            </div>
            <!--          手机号-->
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="tel" class="col-12 col-md-3 text-start">手机号</label>
              <div class="col-12 col-md-9">
                <input  type="tel"
                       name="tel" style="display: none">
                <input
                    type="tel"
                    name="tel"
                    autocomplete="off"
                       @input="phoneNumChange"
                       @change="phoneNumChange"
                    :readonly="telReadonly" @focus="telReadonly=false" @blur="telReadonly=true"
                       @click="phoneNumChange;"
                       @focusout="phoneNumChange"
                        v-model="form.tel"
                    class="form-control" required>
                <div class="invalid-feedback">
                  请输入正确的手机号
                </div>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="code" class="col-12 col-md-3 text-start ">验证码</label>
              <div class="col-12 col-md-9">
                <div class="input-group ">
                  <input type="text" id="code"
                         inputmode="numeric"
                         name="one-time-code"
                         autocomplete="one-time-code"
                         v-model="form.code"  class="form-control"
                         aria-describedby="passwordHelpInline" required>
                  <span class="input-group-text d-flex align-items-center justify-content-center bg-white " id="basic-addon1">
                    <a class="text-primary point-curser" @click="sentCode" v-if="showCountState===1" :disabled="!phoneCurrent">
                      发送验证码
                    </a>
                    <a class="text-primary point-curser" @click="sentCode" v-if="showCountState===2" :disabled="!phoneCurrent">
                      正在发送
                      <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </a>
                    <a class="text-primary not-allowed-curser" v-if="showCountState===3">{{count}} s</a>
                  </span>
                </div>
<!--                <input type="text" id="code"-->
<!--                       inputmode="numeric"-->
<!--                       name="one-time-code"-->
<!--                       autocomplete="one-time-code"-->
<!--                       v-model="form.code"  class="form-control"-->
<!--                       aria-describedby="passwordHelpInline" required>-->
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="inputPassword6" class="col-12 col-md-3 text-start">密码</label>
              <div class="col-12 col-md-9">
                <input type="password" id="password" name="password" v-model="form.password" class="form-control"
                       aria-describedby="passwordHelpInline" required>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 align-items-center ">
              <label for="inputPassword6" class="col-12 col-md-3 text-start">确认密码</label>
              <div class="col-12 col-md-9">
                <input type="password" id="passwordConfirm" name="passwordConfirm" v-model="form.passwordConfirm" class="form-control"
                       aria-describedby="passwordHelpInline" required>
              </div>
            </div>
            <div class="row w-100 g-2 g-sm-3 mt-4 mb-2 align-items-center justify-content-center d-flex">
              <button class="col-10  col-sm-4 btn btn-md btn-primary me-2 py-2" type="submit"
                      :disabled="!(form.name&&form.name.trim())
                      || !(form.tel &&form.tel.trim())
                      || !(form.code &&form.code.trim())
                      || !(form.password &&form.password.trim()) || !(form.passwordConfirm &&form.passwordConfirm.trim()) || loading
                  "
              >
                <span class="spinner-border spinner-border-sm" aria-hidden="true" v-if="loading"></span>
                确定
              </button>
              <button class="col-10 col-sm-4 btn btn-md btn-light py-2" type="button" value="Close!" @click="registModelOpen(false)">
                取消
              </button>
            </div>
          </form>
<!--          <div class="card-footer p-2 text-center"><small>已有账号?</small>-->
<!--            <a class="small font-weight-bold text-primary point-curser" @click="loginModelOpen(true)">去登录</a></div>-->
        </div>

      </div>
    </div>
  </div>

</template>

<script setup>
import {defineEmits, defineProps, onMounted, onUnmounted, reactive, ref, watch} from "vue";
import {Modal} from "bootstrap";
import {registModelOpen,loginModelOpen} from "@/utils/authCheck"
import {useStore} from 'vuex'
import {showToast} from "@/utils/toast";
import {checkAccountExist, newAccount, sendSmsCode} from "@/api/login";
const store = useStore()
const formDom = ref()
const count = ref(0)
let interval = null
const showCountState = ref(1) // 1可以发送验证码，2，号码正在验证中 3，已发送
const phoneCurrent = ref(false) // 电话号码格式正确
let loading = ref(false) // 提交按鈕
// 防止自动填充
const nameReadonly = ref(true)
const telReadonly = ref(true)
const props = defineProps({
  show: {
    default: false
  }
})
const form = reactive({
  name:"",// 用户名
  tel :null,// 电话号码
  code:null,//验证码
  password:null,
  passwordConfirm:null
})
const emits = defineEmits({
  'update:show': (val) => {
    return val;
  },
  'closeMode': (val) => {
    return val;
  },
  'goLogin': (val) => {
    return val;
  }
})
const modelDom = ref() // 当前model
let modelRef; // model实例

// 监测注册的模块
watch(() => store.state.manuAction.registModelOpen,(now, prev) => {
  openRegisterCtr && openRegisterCtr(now?"open":"close")
},{ deep: true})

// 打开或者关闭
const openRegisterCtr = (flag)=>{
  if(!modelRef && modelDom.value){
    modelRef = new Modal(modelDom.value)
  }
  if(flag==="open"){
    modelRef.show()
    loading.value = false
  }else if(flag==='close'){
    modelRef.hide()
  }else{
    modelRef.toggle()
  }
}

// 验证输入的电话号码
const phoneNumChange = ()=>{
  if(!form.tel || !form.tel.trim()){
    phoneCurrent.value = false
    return false
  }
  var phoneReg = /^1[3-9]\d{9}$/
  if(phoneReg.test(form.tel)){
    phoneCurrent.value = true
    return true
  }else{
    phoneCurrent.value = false
    return false
  }
}
//提交
const save = async (event)=>{
  event.preventDefault();
  event.stopPropagation();
  // 验证表单
  // const form = formDom.value
  // form.classList.add('was-validated');
  // if (form.checkValidity() === false) {
  //   return false
  // }
  if(!phoneNumChange()){
    return showToast("warning","请输入正确的电话")
  }
  loading.value = true
  const res = await newAccount({...form,tel:form.tel+""})
  loading.value = false
  if(res.err_code===0){
     showToast("success","注册成功")
    registModelOpen(false) // 关闭注册框
    loginModelOpen(true) // 打开登录框
  //  关闭注册框，打开登录框
  }else{
    showToast("danger",res.err_msg || "注册失败")
  }
}

onMounted(()=>{

})
const sentCode = async ()=>{
  if(!form.name || !form.name.trim()){
    return showToast("warning","账户名不可为空")
  }
  if(phoneNumChange()){ // 1，判断号码是否合格
    showCountState.value = 2
    // 1，验证号码和账号是否被使用
    // const res = await checkAccountExist({name:form.name,tel:form.tel})
    // if(res.err_code!==0){
    //   showCountState.value = 1
    //   return showToast("warning",res.err_msg || "账户名或密码不可注册")
    // }
    // 2，发送验证码
    const cres = await sendSmsCode({tel:form.tel,Mode:0})

    if(cres.err_code===0){ // 已经发送
      showCountState.value = 3
      startCount()
    }else{
      showCountState.value = 1
      return showToast("danger",cres.err_msg || "获取验证码失败")
    }

    // console.log(222,cres)
    //2 验证号码是否被使用


  }else{
    return showToast("warning","请输入正确的电话号码")
  }

}
const startCount = ()=>{
  count.value = 60
  interval = setInterval(()=>{
    count.value = count.value - 1
    if(count.value===0){
      clearInterval(interval)
      showCountState.value = 1
    }
  },1000)
}
onUnmounted(()=>{
  interval && clearInterval(interval)
})

</script>

<style scoped lang="scss">
.form-control{
  height: 3rem;
}
.img-box > img{
  width: 100%;
  height: 100%;
  object-fit: fill; /* 保持图片比例且填满容器 */
}
.input-group{
input{
  border-right: none !important;
}
  .input-group-text{
    //width: 100px;
  }
}
</style>
